// import Cookies from "js-cookie";
// import { storeBasicConfig } from "../redux/action/agent/action";
// import { storeBetLimit, storeGame } from "../redux/action/game/action";

import { filterGameList } from "../redux/action/game/gameAction";
import {
  storeMarqueeList,
  storeVipDetail,
} from "../redux/action/member/memberAction";
import { getMarquee } from "./getApi";

export const BasicApi = (dispatch) => async () => {
  try {
    dispatch(
      filterGameList({
        allGameList: window.gameTypeGroup,
        allGamePlatform: window.platforms,
        allGameType: window.gameType,
        allGame_subtype: window.gameSubType,
        allNewGameList: window.newGames,
        allTopGameList: window.topGames,
        randomlySelectedGames: window.randomlySelectedGames,
        exclusiveBrandGames: window.exclusiveBrandGames,
      })
    );
    dispatch(storeVipDetail(window.vipDetails));

    getMarquee().then((data) => {
      dispatch(storeMarqueeList(data.marquees));
    });
  } catch (error) {
    console.error(error);
  } finally {
  }
};
